import { randomUniqueId } from 'utils'

export const CONFIRM_NODE_ID = `preview-modal-${randomUniqueId()}`
